export interface PageInfo {
  TotalItems: number;
  TotalPages: number;
  CurrentPage: number;
  PageSize: number;
  /** True when the real total is larger than TotalItems (backend counts up to a maximum). */
  TotalIsCapped: boolean;
}

export interface PagedResponse<T> {
  Items: T[];
  PageInfo: PageInfo;
}

export interface PageQuery {
  /** 1-based */
  pageNumber: number;
  pageSize: number;
  filters?: Record<string, string | null | undefined>;
}

export function toPageParams(query: PageQuery): Record<string, string> {
  const params: Record<string, string> = {
    PageNumber: String(query.pageNumber),
    PageSize: String(query.pageSize)
  };
  for (const [key, value] of Object.entries(query.filters ?? {})) {
    if (value) {
      params[key] = value;
    }
  }
  return params;
}
